export const IncludeAll = 'Include All';

export const PRICE_PER_RESPONSE_USD = 10;

export const ANNUAL_INCOME_RANGE = [
  '$25,000 or less',
  '$25,000 - $45,000',
  '$45,000 - $75,000',
  '$75,000 - $100,000',
  '$100,000 - $150,000',
  '$150,000 or more',
  IncludeAll,
];

export const GENDER_FIELD = ['Male', 'Female', IncludeAll];
export const YES_NO_ALL = ['Yes', 'No', IncludeAll];
export const MARTIAL_STATUS = ['Single', 'Married', 'In a relationship', 'Engaged', IncludeAll];
export const EMPLOYMENT_STATUS = [
  'Employed (full time)',
  'Employed (part time)',
  'Self-employed',
  'Work in the gig economy',
  'Unemployed',
  IncludeAll,
];

export const PET_OWNERS_STATUS = [
  'Dog owners',
  'Cat owners',
  IncludeAll,
];

export const CAMPAIGN_TYPE = {
  'poll': 'Poll: Learn about an audience by asking simple questions',
  'ad': 'Ad: Send text and image ads to stay top of mind',
  'coupon': 'Coupon: Send personalized offers to a hyper targeted audience',
  'free': 'UNPAID: Company insight question from Focusloop',
};

export const RESPONSE_TYPE = {
  'yes-no': 'Yes/No',
  'true-false': 'True/False',
  'multi-single-answer': 'Multiple choice (single answer)',
};


export const COLORS = ["#0074D9", "#FF4136", "#2ECC40", "#FF851B", "#7FDBFF", "#B10DC9", "#FFDC00", "#001f3f", "#39CCCC", "#01FF70", "#85144b", "#F012BE", "#3D9970", "#111111", "#AAAAAA"];
